import { CreditDataMain } from "@/types/api/user/home.type.data";
import UploadDocuments from "@/shared/components/common/uploadDocuments";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Divider, TextField } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
interface FirstTabProps{
  userInquiry: CreditDataMain;
  setAddress: Dispatch<SetStateAction<string>>;
  setUploadedImages: Dispatch<SetStateAction<any>>;
  address: string;
}
/**
 * FirstTab
 *
 * تب اول در فرآیند بررسی اطلاعات اعتباری کاربر.
 * شامل:
 * - نمایش اطلاعات پایه کاربر (کد ملی، شماره تلفن، نام پدر، نام و نام خانوادگی)
 * - فیلد آدرس محل سکونت که قابل ویرایش است.
 * - آپلود تصاویر مدارک هویتی: شناسنامه و کارت ملی (رو و پشت)
 *
 * ویژگی‌ها:
 * - استفاده از UploadDocuments برای بارگذاری فایل‌ها و مدیریت state با setUploadedImages.
 * - استفاده از TextField با استایل‌های سفارشی برای هماهنگی با تم تاریک.
 * - نمایش اطلاعات کاربر به صورت فقط خواندنی.
 *
 * @param {Object} props
 * @param {CreditDataMain} props.userInquiry اطلاعات کاربر
 * @param {Dispatch<SetStateAction<string>>} props.setAddress تابع برای ذخیره آدرس کاربر
 * @param {Dispatch<SetStateAction<any>>} props.setUploadedImages تابع برای ذخیره فایل‌های بارگذاری شده
 * @param {string} props.address مقدار فعلی آدرس کاربر
 *
 * @component
 * @returns JSX.Element
 */

const FirstTab = ({userInquiry,setAddress,setUploadedImages,address,}: FirstTabProps) => {
  return (
    <StackKit justifyContent={"space-between"} sx={{ height: "100%", width: "100%" }}>
      <StackKit direction={"column"} alignItems={"start"} sx={{ width: "100%" }}>
        <TypoGraphyKit variant="h6">
          لطفا اطلاعات زیر را تکمیل کنید.
        </TypoGraphyKit>
        <StackKit direction={"row"} justifyContent={"space-around"} sx={{ width: "100%" }} gap={2}>
          <TypoGraphyKit variant="body1" gap={2} sx={{ color: "#000", bgcolor: "#d3d3d3", p: 1.5, borderRadius: 2, flex: 1, textAlign: "center" }}>
            کدملی: {userInquiry?.nid}
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1" gap={2} sx={{ color: "#000", bgcolor: "#d3d3d3", p: 1.5, borderRadius: 2, flex: 1, textAlign: "center" }}>
            شماره تلفن : {userInquiry?.phone}
          </TypoGraphyKit>
          {/*<TypoGraphyKit variant="body1" gap={2} sx={{ color: "#A4A4A4", bgcolor: "#1e1e1e", p: 1.5, borderRadius: 2, flex: 1, textAlign: "center" }}>*/}
          {/*  نام پدر : {userInquiry.father_name}*/}
          {/*</TypoGraphyKit>*/}
        </StackKit>
      <StackKit direction={"row"} justifyContent={"space-between"} sx={{ width: "100%", gap: 2, flexWrap: "wrap",paddingY:2 }}>
          <TypoGraphyKit variant="body1" sx={{ color: "#000", bgcolor: "#d3d3d3", p: 1.5, borderRadius: 2, flex: 1, textAlign: "center" }}>
              نام: {userInquiry?.name}
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1" sx={{ color: "#000", bgcolor: "#d3d3d3", p: 1.5, borderRadius: 2, flex: 1, textAlign: "center" }}>
              نام خانوادگی: {userInquiry?.last_name}
          </TypoGraphyKit>
      </StackKit>

          <StackKit spacing={2} sx={{ width: "100%" }}>
              <TextField
                  fullWidth
                  variant="filled"
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="آدرس محل سکونت"
                  InputProps={{
                      disableUnderline: true,
                      sx: {
                          color: "white",
                          borderRadius: 3,
                          overflow: "hidden",
                          "& .MuiFilledInput-input": {
                              padding: 2,
                          },
                          "& .MuiFilledInput-input::placeholder": {
                              color: "white",
                              opacity: 1,
                          },
                      },
                  }}
              />
          </StackKit>


          {/*<Divider sx={{ bgcolor: "#FFFFFF33", width: "100%" }} />*/}
        <StackKit direction={"column"} justifyContent={"space-around"} alignItems={"start"} sx={{ width: "100%" }}>
          <TypoGraphyKit variant="h6" sx={{paddingY: 2 }}>
            لطفا تصاویر مدارک زیر را بارگذاری کنید. لطفا تصاویر را تا حد امکان
            با کیفیت و در یکی از فرمت های jpg , png, jpeg و حجم حداکثر یک
            مگابایت بارگذاری نمایید.
          </TypoGraphyKit>
          <StackKit direction={"row"} justifyContent={"space-between"} gap={2} sx={{ width: "100%",paddingBottom: 2 }}>
            <UploadDocuments label="بارگذاری عکس صفحه اول شناسنامه" defaultImage={"./shenas.jpg"}
              onUpload={(file: any) => setUploadedImages((prev: any) => ({ ...prev, birthCert: file }))}/>
            <UploadDocuments label="بارگذاری عکس پشت کارت ملی" defaultImage={"./faceCard.jpg"}
              onUpload={(file: any) => {setUploadedImages((prev: any) => ({ ...prev, cardBack: file }));}}/>
            <UploadDocuments label="بارگذاری عکس روی کارت ملی" defaultImage="./bakCard.jpg"
              onUpload={(file: any) => {setUploadedImages((prev: any) => ({...prev, cardFront: file,}));}}/>
          </StackKit>
        </StackKit>
      </StackKit>
    </StackKit>
  );
};

export default FirstTab;
